// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicyPage_container__ZFjy0","content":"PrivacyPolicyPage_content__fYv2L","backLink":"PrivacyPolicyPage_backLink__ui6Ec"};